// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"eT-z","inlineTitle":"fT-z","sponsoredAdsWrapper":"gT-z","marketplaceRecosWrapper":"hT-z"};